import { useEffect } from 'react';
import {
  NavigationType,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

// Opens every new page at the top (owner report 2026-10-04: on a phone the
// footer links "did nothing" -- they did navigate, but the new page kept the
// old scroll position, so all you saw was the same footer again).
//
// Left alone on purpose:
// - Back / Forward (POP): the browser puts you back where you were.
// - Links to a section (/#curriculum): the page scrolls to that section.
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === NavigationType.Pop || hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
}
